export const getSearchInputStyles = () => ({
  searchInputContainer: {
    width: 268,
  },
  searchBox: {
    marginTop: 4,
  },
});

export const searchInputTitleStyles = {
  fontWeight: 600,
};
